import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deleteDriver, useDrivers } from "../../utils/driver";
import { NavItem, NavTabs } from "../layout/Nav";
import { verifyRight } from "../../utils/users";
import ActionsMenu from "../layout/ActionsMenu";
import { StyledTr } from "./bookingContent";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import TrashIcon from "../icons/TrashIcon";
import { OutlineButtonLink } from "../layout/OutlineButton";
import { getDriverAppLink } from "../../utils/driverApp/adminApi";

export default function DriverContent() {
  const { userInfos } = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const [showOnlyInternal, setShowOnlyInternal] = useState(false);
  const { drivers, loaded } = useDrivers();
  const datatable = useRef(null);

  const filteredDrivers = useMemo(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    if (showOnlyInternal) {
      return drivers.slice().filter((driver) => driver.internal);
    }
    return drivers.slice();
  }, [drivers, showOnlyInternal]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const datatableContent = useMemo(() => {
    return (
      <tbody>
        {filteredDrivers.map((driver, index) => {
          let actions = [];
          if (verifyRight(userInfos, "driver", "update")) {
            actions.push({
              link: `/driver/${driver.id}`,
              label: "Modifier",
            });
          }

          actions.push({
            label: "Lien espace chauffeur",
            onClick: async () => {
              try {
                const url = await getDriverAppLink(userInfos.jwt, driver.id);
                await navigator.clipboard.writeText(url);
                window.alert(
                  "Lien copié dans le presse-papiers. Envoyez-le au chauffeur : il ouvre son espace (courses, bons de mission, suivi) sans mot de passe.\n\n" + url
                );
              } catch (e) {
                window.alert("Erreur lors de la génération du lien : " + (e.response?.data?.error || e.response?.data || e.message));
              }
            },
          });

          if (verifyRight(userInfos, "driver", "delete")) {
            actions.push({
              label: "Supprimer",
              onClick: async () => {
                if (
                  !window.confirm(
                    "Voulez-vous vraiment supprimer ce chauffeur ?"
                  )
                )
                  return;

                await deleteDriver(userInfos, [driver.id]);
                window.location.reload();
              },
            });
          }
          return (
            <StyledTr
              className={checked.includes(driver.id) ? "checked" : ""}
              key={driver.id}
            >
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={checked.includes(driver.id)}
                  name="bulk_action"
                  value={driver.id}
                  onChange={handleCheckbox}
                />
              </td>
              <td>{index + 1}</td>
              <td>{driver.name || "N/A"}</td>
              <td>{driver.phone || "N/A"}</td>
              <td>{driver.email || "N/A"}</td>
              <td>{driver.internal ? "Oui" : "Non"}</td>
              <td>{driver?.company?.name || "N/A"}</td>
              <td>
                <ActionsMenu items={actions} />
              </td>
            </StyledTr>
          );
        })}
      </tbody>
    );
  }, [filteredDrivers, userInfos, checked]);

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [filteredDrivers, loaded]);

  const handleDeleteDriver = useCallback(async () => {
    if (checked.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ces chauffeurs ?"))
        return;
      await deleteDriver(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    if (checked.length) {
      let actions = [];
      if (verifyRight(userInfos, "driver", "delete"))
        actions.push({
          label: <TrashIcon />,
          onClick: handleDeleteDriver,
        });
      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={actions}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeleteDriver, userInfos]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <NavTabs className="titles">
          {verifyRight(userInfos, "company", "read") && (
            <NavItem>
              <Link to="/company">Entreprises</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "driver", "read") && (
            <NavItem className="active">
              <Link to="/driver">Chauffeurs</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "vehicle", "read") && (
            <NavItem>
              <Link to="/vehicle">Véhicules</Link>
            </NavItem>
          )}
        </NavTabs>
        <div className="header-toolbar">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "15px",
            }}
          >
            <div className="form-check" style={{ marginRight: "10px" }}>
              <input
                type="checkbox"
                className="form-check-input"
                id="internalFilter"
                checked={showOnlyInternal}
                onChange={(e) => setShowOnlyInternal(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="internalFilter">
                Afficher uniquement les chauffeurs internes
              </label>
            </div>
          </div>
          {verifyRight(userInfos, "driver", "create") && (
            <OutlineButtonLink to="/addDriver/">
              <i className="la la-plus"></i>
              Nouveau chauffeur
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="kt-portlet--mobile">
          <div className="kt-portlet__body" style={{ overflowX: "scroll" }}>
            <table
              className="table table-striped- table-bordered table-hover table-checkable"
              id="datatable"
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "5%", textAlign: "center" }}
                    data-sort="false"
                  >
                    Selection
                  </th>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "25%" }}>Nom</th>
                  <th style={{ width: "15%" }}>Téléphone</th>
                  <th style={{ width: "15%" }}>Mail</th>
                  <th style={{ width: "10%" }}>Interne</th>
                  <th style={{ width: "20%" }}>Compagnie</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              {datatableContent}
            </table>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
